import { useState, useCallback } from "react";
import type { MeetingDetails } from "@core/features/videoMeeting";
import { VideoMeetingJoin } from "./VideoMeetingJoin";

type Props = {
  meetingDetails: MeetingDetails;
  isDevicesLoading: boolean;
  meetingStartTime?: string | null;
  onJoin: () => Promise<void>;
};

export function VideoMeetingJoinContainer({
  meetingDetails,
  isDevicesLoading,
  meetingStartTime,
  onJoin,
}: Props) {
  const [isActionLoading, setIsActionLoading] = useState(false);

  const handleJoin = useCallback(async () => {
    setIsActionLoading(true);
    try {
      await onJoin();
    } finally {
      setIsActionLoading(false);
    }
  }, [onJoin]);

  return (
    <VideoMeetingJoin
      meetingDetails={meetingDetails}
      isDevicesLoading={isDevicesLoading}
      meetingStartTime={meetingStartTime ?? undefined}
      onJoinMeeting={handleJoin}
      isActionLoading={isActionLoading}
    />
  );
}
